import {Injectable} from '@angular/core';

@Injectable()
export class EnvironnementRequiredService {
  private _forceUpgrade: boolean;
  private _message: string;
  private _lockApp: boolean;

  get lockApp(): boolean {
    return this._lockApp;
  }

  set lockApp(value: boolean) {
    this._lockApp = value;
  }

  get forceUpgrade(): boolean {
    return this._forceUpgrade;
  }

  set forceUpgrade(value: boolean) {
    this._forceUpgrade = value;
  }

  get message(): string {
    return this._message;
  }

  set message(value: string) {
    this._message = value;
  }
}



// WEBPACK FOOTER //
// ./src/core/app/environnement-required.service.ts